import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import coinIcon from '../../../asset/img/common/coin_icon.svg';

import Typography from '../../../components/common/Typography';
import BackgroundBox from '../../../components/common/BackgroundBox';
import { resultReportData } from '../../../common/data';
import Chips from '../../../components/common/Chips';

const ResultReport = ({ resultData }) => {
  const { t } = useTranslation('resultQuery');
  const { myInfo } = useSelector(state => state.myInfo);
  const reportData = resultReportData(t);
  return (
    <div className="resultReport">
      <BackgroundBox />

      <Typography className="body1Bold">{t('title2')}</Typography>

      <div>
        {reportData.map((item, index) => (
          <div key={item.value} className="reportItem displayFlexColumn" style={{ gap: '10px' }}>
            <div className="displayFlex" style={{ gap: '8px' }}>
              <img
                src={coinIcon}
                alt={index == 0 ? `‘${myInfo.htmInsaPerNm}’${item.label}` : item.label}
              />
              <Typography className="body2Bold">
                {index == 0 ? `‘${myInfo.htmInsaPerNm}’${item.label}` : item.label}
              </Typography>
            </div>
            <div className="displayFlexColumn" style={{ gap: '8px' }}>
              {item.itemList.map(item => {
                let value = '';
                if (!resultData[item.key] || resultData[item.key] === '-') {
                  value = '-';
                } else {
                  value = `${resultData[item.key]} ${t('report.price')}`;
                }

                const fontStyle = item.fontStyle ? item.fontStyle : 'body2Medium';
                if (item.fontStyle && index == 1 && resultData[item.key] === '-') {
                  value = <Chips color="error">검토중</Chips>;
                }

                return (
                  <div
                    key={item.key}
                    className="displayFlex"
                    style={{ justifyContent: 'space-between', gap: '24px' }}>
                    <Typography className={fontStyle}>{item.label}</Typography>
                    <Typography className={fontStyle}>{value}</Typography>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ResultReport;
